import type { CompareProduct } from '../types';

export function renderProductCard(p: CompareProduct): string {
  const variants = p.variants || [];

  const activeVariantId = p.currentVariantId?.toString() || variants[0]?.id?.toString();

  const currentVariant = variants.find((v) => String(v.id) === String(activeVariantId));

  const isAvailable = currentVariant ? currentVariant.available : false;

  const hasDiscount = !!(currentVariant?.compare_at_price && currentVariant.compare_at_price !== currentVariant.price);

  const addToCartText = window.compareTranslations?.addToCart;
  const fromPriceText = window.compareTranslations?.from_price;

  const priceHtml = hasDiscount
    ? `
      <div class="flex flex-wrap items-center gap-2x pt-2x mt-auto">
        <div class="flex items-center gap-1x">
          <span class="body-s text-content-primary">${fromPriceText}</span>

          <span class="badge-discount px-1x rounded-sm">
            <span class="heading-xs text-content-primary main-price-display">
              ${currentVariant ? currentVariant.price : p.price}
            </span>
          </span>
        </div>

        <span class="body-s text-content-secondary line-through compare-price-display">
          ${currentVariant?.compare_at_price || ''}
        </span>
      </div>
    `
    : `
      <div class="pt-2x mt-auto body-s text-content-primary">
        ${fromPriceText}
        <span class="heading-xs main-price-display">
          ${currentVariant ? currentVariant.price : p.price}
        </span>
      </div>
    `;

  return `
    <div class="flex flex-col flex-1 w-[144px] m:w-[200px] shrink-0 relative group">
      <button
        class="absolute bg-neutral-white -top-2x -right-1x z-[2] p-2x remove-compare-btn rounded-pill btn-outline"
        data-id="${p.id}"
      >
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor" class="size-4x">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path>
        </svg>
      </button>
      <a href="${p.url}"
        class="flex flex-col flex-1 gap-3x px-2x w-full"
        data-product-card
        data-main-card-id="${p.id}"
      >
        <div
          class="compare-match-chip absolute text-center -top-8x w-full z-2 hidden"
          data-product-chip="${p.id}"
        ></div>



        <div class="aspect-square bg-secondary rounded-m overflow-hidden flex items-center justify-center">
          <img
            src="${p.image}"
            alt="${p.title}"
            class="max-w-full max-h-full object-contain mix-blend-multiply p-2x"
            loading="lazy"
          >
        </div>

        <div class="flex flex-col gap-1x">
          <h3 class="label-s line-clamp-1">
            ${p.title}
          </h3>

          <p class="body-s line-clamp-1">
            ${p.features ? p.features.join(' / ') : ''}
          </p>

          ${priceHtml}
        </div>
      </a>
        <form
          class="js-compare-add-to-cart form flex flex-col space-4x"
          enctype="multipart/form-data"
        >
          <input type="hidden" name="id" value="${activeVariantId}">

          <div class="flex flex-col">
            <button
              type="button"
              data-add-to-cart
              class="btn-mono btn-small rounded-pill w-full justify-center mt-4x"
              ${!isAvailable ? 'disabled' : ''}
            >
              <span class="submit-button-text">
                ${isAvailable ? addToCartText : 'Loppuunmyyty'}
              </span>
            </button>
          </div>
        </form>
    </div>
  `;
}
